import { render, staticRenderFns } from "./Permisos.view.vue?vue&type=template&id=0614f7e3"
import script from "./Permisos.view.vue?vue&type=script&lang=js"
export * from "./Permisos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports